import { OnInit, Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { DependenciaJefesModel } from 'src/app/models/dependencia-jefes.model';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UtilService } from 'src/app/shared/services/util.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { FuncionarioModel, FuncionarioBasicoModel, FuncionarioListasModel } from 'src/app/models/funcionario.model';
import { FuncionarioDependenciaDTO } from 'src/app/models/FuncionarioDependenciaDTO.model';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'app-relacion-jefe-sede',
    templateUrl: './relacion-jefe-sede.component.html'
})

export class RelacionJefeSedeComponent implements OnInit {

    public funcionariosJefes: FuncionarioDependenciaDTO[] = [];
    public funcionariosList: FuncionarioListasModel[] = [];
    public funcionarioSeleccionado: FuncionarioListasModel;


    public filtroNombre: string;
    public consultaJefes: DependenciaJefesModel[];
    public BanderaGuardarActualizar: boolean;
    public filtroSede: string;
    public listaSede: DetalleDominio[];
    public campoSede: string;
    public campoDependencia: string;
    public campoJefe: string;
    public campoJefeEditar: string;
    public consultaDependencias: DependenciaJefesModel[];
    public modalOptionsGuardar: ConfirmationModalOptions;
    public funcionarios: FuncionarioModel[];
    public mostrarCampoJefe: boolean;
    public habilitarDependenciaSede: boolean;
    public p: any;
    public dependencias: FuncionarioDependenciaDTO[]; 

    constructor(
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService
    ) {
        this.consultaJefes = [];
        this.BanderaGuardarActualizar = false;
        this.listaSede = [];
        this.consultaDependencias = [];
        this.campoDependencia = undefined;
        this.campoSede = undefined;
        this.campoJefe = undefined;
        this.funcionarios = [];
        this.habilitarDependenciaSede = false;
    }

    ngOnInit() {
        this.obtenerSedes();
        this.obtenerJefes();
        this.modalOptionsGuardar = new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_GUARDAR_SEDE, 
            'SI', 'NO', 'fa fa-save', false, false, 'Guardar', null, 'btn btnGuardar btn-secondary');
    }

    /**
     * Metodo encargado de obtener las sede existentes
     */
    obtenerSedes() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.listaSede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener las Sedes');
            }
        );
    }

    /**
     * Metodo que consulta jefe que pertenece a dicha dependencia y sede
     */
    obtenerJefes() {
        this.spinner.show();
        const serviceProvider = 'consultarJefesAsignados';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.funcionariosJefes = data;
                this.filtrarJefes();
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible consultar el jefe');
            }
        );
    }

    private filtrarJefes() {
        this.funcionariosList = [];
        for (const item of this.funcionariosJefes) {
            let funcionario = this.funcionariosList.find(x => x.numeroIdFuncionario === item.numeroIdFuncionario &&
                x.numeroIdFuncionario === item.numeroIdFuncionario);
            if (!funcionario) {
                this.funcionariosList.push(
                    new FuncionarioListasModel(item.tipoIdFuncionario, item.numeroIdFuncionario, item.nombreCompleto));
            }
        }
    }

    consultarFuncionario() {
        if (this.funcionarioSeleccionado !== undefined) {
            this.dependencias = this.funcionariosJefes.filter(
                dep => dep.tipoIdFuncionario === this.funcionarioSeleccionado.tipoIdFuncionario 
                    && dep.numeroIdFuncionario === this.funcionarioSeleccionado.numeroIdFuncionario);
        } else {
            this.dependencias = undefined;
        }
    }

    /**
     *  Metodo encargado de llamar el servicio de Back para realizar el Guardado
     * @param opcion respuesta del mensaje de confirmacion
     */
    getConfirmationGuardar(opcion: boolean, dependencia: FuncionarioDependenciaDTO) {
        if (opcion[0]) {
            if (dependencia.sede !== undefined) {
                const filtro = {
                    idDependencia: dependencia.dependencia,
                    nombreDependencia: dependencia.dependenciaNombre,
                    sede: dependencia.sede,
                    tipoIdJefe: dependencia.tipoIdFuncionario,
                    numeroIdJefe: dependencia.numeroIdFuncionario,
                    valor: 'Editar'
                };

                this.spinner.show();
                const serviceProvider = 'guardarJefe';
                const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
                    this.urlService.hostAPI_FUNCIONARIOS);
                this.global.postGenerico(url, filtro).subscribe(
                    data => {
                        this.consultaJefes = data;
                        this.spinner.hide();
                        this.alertService.generateAlertSuccess('Se guardó información exitosamente', 'Exitoso');
                        this.refrescar();
                    }, err => {
                        if (err.status === 500) {
                            this.cathException(err.error.message);
                        } else {
                            this.cathException('No es posible guardar el la información');
                        }
                    }
                );
            } else {
                this.alertService.generateAlertError('Debe asignar una sede al registro', '');
            }
        }
    }

    /**
     * Metodo que realiza la volver a la pantalla principal
     */
    refrescar() {
        this.dependencias = undefined;
        this.obtenerJefes();
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
